export default __webpack_public_path__ + "static/media/BTT.611f21ae.jpg";